import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import fetchIntegrationAPI from '../../common/fetchIntegrationAPI';
import { IThunkApi } from '../timesheet/timesheetSlice';
import { GetSystemIntegrationId } from './GetIntegrationId';
import { ShowToast } from '../../common/Toastr';
import { CalendarStateClass } from './CalendarSliceClass';
import moment from 'moment';

const initialState: CalendarStateClass = {
    status: 'idle',
    eventList: [],
    loading: false,
    AccountEmployeeId: 0,
    AccountEmployeeTimeEntryPeriodId: null,
    AccountId: 0,
    Approved: '',
    ApprovedByEmployeeId: null,
    ApprovedOn: '',
    BillableHours: '',
    EmployeeName: '',
    InApproval: '',
    IsEntered: '',
    IsLockedYNID: '',
    LockApprovedRecords: '',
    LockSubmittedRecords: '',
    NonBillableHours: '',
    PeriodDescription: '',
    Rejected: '',
    RejectedByEmployeeId: 0,
    RejectedOn: '',
    SNo: '',
    SerialNo: '',
    Submitted: '',
    SubmittedDate: '',
    TimeEntryEndDate: '',
    TimeEntryStartDate: '',
    TimeEntryViewType: '',
    TotalHours: '',
    TotalMinutes: '',
    integrationData: [],
    integrationValue: [],
    googleEvents: [],
    outlookEvents: [],
    googleConnected: null,
    outlookConnected: null,
    timeoffEvents: [],
    googleHolidayEvents: [],
    outlookHolidayEvents: [],
    timeEntryData: null,
    isLocked: false,
    customFields: [],
    isShowCustomFields: false,
    GoogleColorCode: '',
    OutlookColorCode: '',
    reloader: false,
    calendarStartDate: new Date(),
    calendarEndDate: new Date(),
    workingDayType: [],
    DummyRangePeriod: []
}

export const addEventCalendar = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/AddEvent',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/Calendar', 'POST', arg, true);
                const json = await response.json();
                if (json.StatusCode === '201') {
                    ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                } else {
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                }
            } catch (err) {
                console.log(err, "error")
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getCalendarEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/getCalendarEvent',
        async (arg, thunkApi) => {
            try {
                const { AccountEmployeeId, StartDate, EndDate } = arg;
                if (StartDate && EndDate) {
                    const response = await fetchIntegrationAPI(`api/Calendar/${AccountEmployeeId}/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const UpdateEventCalendar = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/UpdateEvent',
        async (arg, thunkApi) => {
            try {
                const { CalendarEventId } = arg;
                const response = await <any>fetchIntegrationAPI('api/Calendar/' + CalendarEventId, 'PUT', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                if (json.StatusCode === '200') {
                    ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                } else {
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const DeleteEventCalendar = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/DeleteEvent',
        async (CalendarEventId, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/Calendar/' + CalendarEventId, 'DELETE', true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                if (json.StatusCode === '200') {
                    ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                } else {
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const gettimesheetData = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/getTimesheetData',
        async (arg, thunkApi) => {
            try {
                const { AccountEmployeeId, currentDate, endDate } = arg;
                if (AccountEmployeeId && currentDate) {
                    const response = await fetchIntegrationAPI(`api/Timesheet/GetAccountEmployeeTimesheetPeriod/${AccountEmployeeId}/${currentDate}/${endDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const gettimesheetRecord = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/getTimesheetRecord',
        async (arg, thunkApi) => {
            try {
                const { AccountEmployeeId, startDate, endDate } = arg;
                if (AccountEmployeeId && startDate && endDate) {
                    const response = await fetchIntegrationAPI(`api/Timesheet/GetAccountEmployeeTimeEntry/${AccountEmployeeId}/${startDate}/${endDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addCalendarTimeEntry = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/addCalendarTimeEntry',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/Timesheet', 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                if (json.StatusCode === '201') {
                    ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                } else {
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                }
                return json;
            } catch (err) {
                thunkApi.rejectWithValue(err)
                ShowToast('Error', err, "error", "toast-top-right");
            }
        }
    )

export const GetAccountEmployeeTimeEntryCustomFields = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'calendar/GetAccountEmployeeTimeEntryCustomFields',
        async (_, thunkApi) => {
            try {

                const response = await fetchIntegrationAPI(`api/Timesheet/GetAccountEmployeeTimeEntryCustomFields`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json.Data;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetAccountWorkingDayType = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'calendar/GetAccountWorkingDayType',
        async (_, thunkApi) => {
            try {

                const response = await fetchIntegrationAPI(`api/Timesheet/GetAccountWorkingDayType`, 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json.Data;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )


export const UpdateCalendarTimeEntry = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/UpdateCalendarTimeEntry',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/Timesheet', 'PUT', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                if (json.StatusCode === '200') {
                    ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                } else {
                    ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const getIntegrations = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'calendar/AccountIntegration',
        async (_, thunkApi) => {
            try {
                const response = await fetchIntegrationAPI('api/AccountIntegration/AccountHolidayCalendarIntegration', 'GET', "", true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json.Data;
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetGoogleCalendarEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/GetGoogleCalendarEvents',
        async (arg, thunkApi) => {
            try {
                const { StartDate, EndDate } = arg;
                if (StartDate && EndDate) {
                    const response = await fetchIntegrationAPI(`api/GoogleCalendarAuth/GetGoogleCalendarEvents/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetOutlookCalendarEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/GetOutlookCalendarEvents',
        async (arg, thunkApi) => {
            try {
                const { StartDate, EndDate } = arg;
                const rootState = thunkApi.getState() as RootState;
                const cultureInfoName = rootState.globalState.cultureInfoName;
                if (StartDate && EndDate) {
                    const response = await fetchIntegrationAPI(`api/OutlookCalendarAuth/GetOutlookCalendarEvents/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    // return json.Data;
                    return {
                        ...json.Data,
                        cultureInfoName,
                    };
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addEventInGoogle = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/AddEventInGoogle',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/GoogleCalendarAuth/CreateGoogleCalendarEvent', 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const addEventInOutlook = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/addEventInOutlook',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/OutlookCalendarAuth/CreateOutlookCalendarEvent', 'POST', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetTimeoffCalendarEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/GetTimeoffCalendarEvents',
        async (arg, thunkApi) => {
            try {
                const { AccountEmployeeId, StartDate, EndDate } = arg;
                if (StartDate && EndDate) {
                    const response = await fetchIntegrationAPI(`api/TimeOff/${AccountEmployeeId}/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )
export const MarkCalendarReminderAsRead = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'calendar/MarkCalendarReminderAsRead',
        async (arg, thunkApi) => {
            try {
                const response = await <any>fetchIntegrationAPI('api/Calendar/MarkCalendarReminderAsRead', 'PUT', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                // if (json.StatusCode === '200') {
                //     ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                // } else {
                //     ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                // }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const calendarSlice = createSlice({
    name: 'calendar',
    initialState: initialState,
    reducers: {
        updateEventFalg: (state, action) => {
            state.loading = action.payload
        },
        updateCustomFieldFalg: (state, action) => {
            state.isShowCustomFields = action.payload
        },
        updateDateOfCalendar: (state, action) => {
            state.calendarStartDate = action?.payload?.calendarStartDate;
            state.calendarEndDate = action.payload?.calendarEndDate;
        },
        UpdateGoogleEventState: (state, action) => {
            state.googleEvents = action.payload;
            state.googleHolidayEvents = action.payload;
        },
        UpdateOutlookEventState: (state, action) => {
            state.outlookEvents = action.payload;
            state.outlookHolidayEvents = action.payload;
        },
        UpdateGoogleHolidayState: (state, action) => {
            state.googleHolidayEvents = action.payload;
        },
        UpdateOutlookHolidayState: (state, action) => {
            state.outlookHolidayEvents = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(addEventCalendar.pending, (state, action) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(addEventCalendar.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(addEventCalendar.rejected, (state) => {
                state.status = 'failed'
                state.reloader = false;
            })
            .addCase(getCalendarEvents.pending, (state, action) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(getCalendarEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                state.eventList = action.payload
            })
            .addCase(getCalendarEvents.rejected, (state) => {
                state.status = 'failed'
                state.reloader = false;
                state.eventList = [];
            })
            .addCase(UpdateEventCalendar.pending, (state, action) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(UpdateEventCalendar.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(UpdateEventCalendar.rejected, (state) => {
                state.status = 'failed'
                state.reloader = false;
            })
            .addCase(gettimesheetData.pending, (state, action) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(gettimesheetData.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                const result = action?.payload;
                state.DummyRangePeriod = result;
                if (result?.length > 0) {
                    state.AccountEmployeeId = result[0].AccountEmployeeId;
                    state.AccountEmployeeTimeEntryPeriodId = result[0].AccountEmployeeTimeEntryPeriodId;
                    state.AccountId = result[0].AccountId;
                    state.Approved = result[0].Approved;
                    state.ApprovedByEmployeeId = result[0].ApprovedByEmployeeId;
                    state.ApprovedOn = result[0].ApprovedOn;
                    state.BillableHours = result[0].BillableHours;
                    state.EmployeeName = result[0].EmployeeName;
                    state.InApproval = result[0].InApproval;
                    state.IsEntered = result[0].IsEntered;
                    state.IsLockedYNID = result[0].IsLockedYNID;
                    state.LockApprovedRecords = result[0].LockApprovedRecords;
                    state.LockSubmittedRecords = result[0].LockSubmittedRecords;
                    state.NonBillableHours = result[0].NonBillableHours;
                    state.PeriodDescription = result[0].PeriodDescription;
                    state.Rejected = result[0].Rejected;
                    state.RejectedByEmployeeId = result[0].RejectedByEmployeeId;
                    state.RejectedOn = result[0].RejectedOn;
                    state.SNo = result[0].SNo;
                    state.SerialNo = result[0].SerialNo;
                    state.Submitted = result[0].Submitted;
                    state.SubmittedDate = result[0].SubmittedDate;
                    state.TimeEntryEndDate = result[0].TimeEntryEndDate;
                    state.TimeEntryStartDate = result[0].TimeEntryStartDate;
                    state.TimeEntryViewType = result[0].TimeEntryViewType;
                    state.TotalHours = result[0].TotalHours;
                    state.TotalMinutes = result[0].TotalMinutes;
                    state.isLocked = ((result[0].LockApprovedRecords && Boolean(result[0].Approved)) || (result[0].LockSubmittedRecords && Boolean(result[0].Submitted)) ? true : false);
                }
            })
            .addCase(gettimesheetData.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(getIntegrations.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(getIntegrations.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                const result = action?.payload;
                state.integrationData = result;
                state.GoogleColorCode = result?.AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '3b00775f-9b50-4a7d-926f-1192e2e3033e')?.ColorCode;
                state.OutlookColorCode = result?.AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '6e0e6a9c-7a37-4bda-8d6a-d7d61f00b828')?.ColorCode;
                state.integrationValue = GetSystemIntegrationId(action.payload?.AccountIntegrations);
                if (Object.entries(result).length > 0) {
                    state.googleConnected = result?.AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '3b00775f-9b50-4a7d-926f-1192e2e3033e');
                    state.outlookConnected = result?.AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '6e0e6a9c-7a37-4bda-8d6a-d7d61f00b828');
                }
            })
            .addCase(getIntegrations.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(GetGoogleCalendarEvents.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(GetGoogleCalendarEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                const result = action.payload;
                if (result?.PrimaryEvents?.length > 0) {
                    const data = result?.PrimaryEvents?.map((item: any) => ({
                        id: item?.Id,
                        title: item?.Summary,
                        start: item?.StartDateTime,
                        end: item?.EndDateTime,
                        url: item?.HtmlLink,
                        extendedProps: {
                            type: 'google',
                            OrganizerEmail: item?.OrganizerEmail,
                            StartTimeZone: item?.StartTimeZone,
                            EndTimeZone: item?.EndTimeZone,
                            Description: item?.Description
                        },
                    }))
                    state.googleEvents = data;
                }
                if (result?.HolidayCalendars?.length > 0) {
                    const data = result?.HolidayCalendars.map((item: any) => ({
                        id: item?.Id,
                        title: item?.Summary,
                        start: item?.StartDateTime,
                        end: item?.EndDateTime,
                        url: item?.HtmlLink,
                        extendedProps: {
                            type: 'external',
                            OrganizerEmail: item?.OrganizerEmail,
                            StartTimeZone: item?.StartTimeZone,
                            EndTimeZone: item?.EndTimeZone,
                            Description: item?.Description
                        },
                    }))
                    state.googleHolidayEvents = data;
                }
            })
            .addCase(GetGoogleCalendarEvents.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(GetOutlookCalendarEvents.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(GetOutlookCalendarEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                const result = action.payload;
                const { cultureInfoName } = action.payload;
                if (result?.PrimaryEvents.length > 0) {
                    const data = result?.PrimaryEvents.map((item: any) => {
                        // const start = moment.utc(item.StartDateTime).tz(cultureInfoName.toString()).format();
                        // const end = moment.utc(item.EndDateTime).tz(cultureInfoName.toString()).format();
                        const start = moment.utc(item.StartDateTime).locale(cultureInfoName).format();
                        const end = moment.utc(item.EndDateTime).locale(cultureInfoName).format();

                        return ({
                            id: String(item.Id),
                            title: item?.Subject,
                            start: start,//item?.StartDateTime,
                            end: end, //item?.EndDateTime,
                            url: item?.WebLink,
                            extendedProps: {
                                type: 'outlook',
                                OrganizerEmail: item?.OrganizerEmail,
                                StartTimeZone: item?.StartTimeZone,
                                EndTimeZone: item?.EndTimeZone,
                                Description: item?.BodyPreview ?? ''
                            },
                        })
                    })
                    state.outlookEvents = data;
                }
                if (result?.HolidayCalendars?.length > 0) {
                    const data = result?.HolidayCalendars.map((item: any) => ({
                        id: String(item.Id),
                        title: item?.Subject,
                        start: item?.StartDateTime,
                        end: item?.EndDateTime,
                        url: item?.WebLink,
                        allDay: true,
                        extendedProps: {
                            type: 'external',
                            OrganizerEmail: item?.OrganizerEmail,
                            StartTimeZone: item?.StartTimeZone,
                            EndTimeZone: item?.EndTimeZone,
                            Description: item?.BodyPreview
                        },
                    }))
                    state.outlookHolidayEvents = data;
                }
            })
            .addCase(GetOutlookCalendarEvents.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(addEventInGoogle.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(addEventInGoogle.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(addEventInGoogle.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(addEventInOutlook.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(addEventInOutlook.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(addEventInOutlook.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(GetTimeoffCalendarEvents.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(GetTimeoffCalendarEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                state.timeoffEvents = action?.payload;
            })
            .addCase(GetTimeoffCalendarEvents.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(gettimesheetRecord.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(gettimesheetRecord.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                // state.timeEntryData = action.payload[0];
            })
            .addCase(gettimesheetRecord.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(addCalendarTimeEntry.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(addCalendarTimeEntry.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(addCalendarTimeEntry.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(GetAccountEmployeeTimeEntryCustomFields.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(GetAccountEmployeeTimeEntryCustomFields.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                state.customFields = action?.payload;
            })
            .addCase(GetAccountEmployeeTimeEntryCustomFields.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(GetAccountWorkingDayType.pending, (state) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(GetAccountWorkingDayType.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
                state.workingDayType = action?.payload;
            })
            .addCase(GetAccountWorkingDayType.rejected, (state) => {
                state.status = 'failed';
                state.reloader = false;
            })
            .addCase(MarkCalendarReminderAsRead.pending, (state, action) => {
                state.status = 'loading';
                state.reloader = true;
            })
            .addCase(MarkCalendarReminderAsRead.fulfilled, (state, action) => {
                state.status = 'idle';
                state.reloader = false;
            })
            .addCase(MarkCalendarReminderAsRead.rejected, (state, action) => {
                state.status = 'failed'
                state.reloader = false;
            })

    },
})

export const { updateEventFalg, updateCustomFieldFalg, updateDateOfCalendar, UpdateGoogleEventState, UpdateOutlookEventState, UpdateGoogleHolidayState, UpdateOutlookHolidayState } = calendarSlice.actions
export const calendarState = (state: RootState) => state.calendar;
export default calendarSlice.reducer